/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetSequenceStepMasters200ResponseInner } from '../models';
/**
 * SequenceStepMasterApi - axios parameter creator
 * @export
 */
export const SequenceStepMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * シーケンスステップマスター一覧取得API
         * @summary シーケンスステップマスター一覧取得API
         * @param {number} sequenceMasterId シーケンスマスターID
         * @param {Array<string>} [fields] 取得フィールド
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSequenceStepMasters: async (sequenceMasterId: number, fields?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sequenceMasterId' is not null or undefined
            assertParamExists('getSequenceStepMasters', 'sequenceMasterId', sequenceMasterId)
            const localVarPath = `/api/user/sequence/masters/{sequenceMasterId}/steps`
                .replace(`{${"sequenceMasterId"}}`, encodeURIComponent(String(sequenceMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields[]'] = fields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SequenceStepMasterApi - functional programming interface
 * @export
 */
export const SequenceStepMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SequenceStepMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * シーケンスステップマスター一覧取得API
         * @summary シーケンスステップマスター一覧取得API
         * @param {number} sequenceMasterId シーケンスマスターID
         * @param {Array<string>} [fields] 取得フィールド
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSequenceStepMasters(sequenceMasterId: number, fields?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSequenceStepMasters200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSequenceStepMasters(sequenceMasterId, fields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SequenceStepMasterApi - factory interface
 * @export
 */
export const SequenceStepMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SequenceStepMasterApiFp(configuration)
    return {
        /**
         * シーケンスステップマスター一覧取得API
         * @summary シーケンスステップマスター一覧取得API
         * @param {number} sequenceMasterId シーケンスマスターID
         * @param {Array<string>} [fields] 取得フィールド
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSequenceStepMasters(sequenceMasterId: number, fields?: Array<string>, options?: any): AxiosPromise<Array<GetSequenceStepMasters200ResponseInner>> {
            return localVarFp.getSequenceStepMasters(sequenceMasterId, fields, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SequenceStepMasterApi - interface
 * @export
 * @interface SequenceStepMasterApi
 */
export interface SequenceStepMasterApiInterface {
    /**
     * シーケンスステップマスター一覧取得API
     * @summary シーケンスステップマスター一覧取得API
     * @param {number} sequenceMasterId シーケンスマスターID
     * @param {Array<string>} [fields] 取得フィールド
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SequenceStepMasterApiInterface
     */
    getSequenceStepMasters(sequenceMasterId: number, fields?: Array<string>, options?: AxiosRequestConfig): AxiosPromise<Array<GetSequenceStepMasters200ResponseInner>>;

}

/**
 * Request parameters for getSequenceStepMasters operation in SequenceStepMasterApi.
 * @export
 * @interface SequenceStepMasterApiGetSequenceStepMastersRequest
 */
export interface SequenceStepMasterApiGetSequenceStepMastersRequest {
    /**
     * シーケンスマスターID
     * @type {number}
     * @memberof SequenceStepMasterApiGetSequenceStepMasters
     */
    readonly sequenceMasterId: number

    /**
     * 取得フィールド
     * @type {Array<string>}
     * @memberof SequenceStepMasterApiGetSequenceStepMasters
     */
    readonly fields?: Array<string>
}

/**
 * SequenceStepMasterApi - object-oriented interface
 * @export
 * @class SequenceStepMasterApi
 * @extends {BaseAPI}
 */
export class SequenceStepMasterApi extends BaseAPI implements SequenceStepMasterApiInterface {
    /**
     * シーケンスステップマスター一覧取得API
     * @summary シーケンスステップマスター一覧取得API
     * @param {SequenceStepMasterApiGetSequenceStepMastersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SequenceStepMasterApi
     */
    public getSequenceStepMasters(requestParameters: SequenceStepMasterApiGetSequenceStepMastersRequest, options?: AxiosRequestConfig) {
        return SequenceStepMasterApiFp(this.configuration).getSequenceStepMasters(requestParameters.sequenceMasterId, requestParameters.fields, options).then((request) => request(this.axios, this.basePath));
    }
}
